import React from "react";
import { Vector3, Tools } from "@babylonjs/core";
import { Engine, Scene } from "react-babylonjs";
import Select from "react-select";
import { LightbarPreviewConstant as LPC, LIGHT_COLORS } from "../../../services/Constant";

const LightBarPreviewComponent = ({ lightData, PW, PH, closeLightbarPreviewModel, tooltipData }) => {
  let lightbar = tooltipData.replace(/<br \/>/gi, "<br>");
  lightbar = lightbar.replace(/<br\/>/gi, "<br>");
  lightbar = lightbar.split("<br>");
  const intensityOptions = [
    { value: "high", label: "High" },
    { value: "steady", label: "Steady" },
    { value: "zero", label: "High" },
  ];
  return (
    <>
      <div id="previewLightbar-modal" className="m-auto">
        <div className="modal-dialog m-0">
          <div className="modal-content">
            <div className="d-flex align-items-center">
              <h2 className="modal-title text-white text-uppercase mt-0">PREVIEW</h2>
              <div className="close-icon text-end ms-auto">
                <button type="button" className="close" data-dismiss="modal" onClick={closeLightbarPreviewModel}>
                  <span aria-hidden="true">
                    <i className="fa fa-times text-red" />
                  </span>
                </button>
              </div>
            </div>
            <div class="text-white mt-10">
              {lightbar.map((data) => (
                <div className="text-white mt-10">{data}</div>
              ))}
            </div>
            <div className="canvas-position mb-5" style={{ height: `${PH}px` }}>
              <Engine canvasId="sample-canvas">
                <Scene clearColor={LPC.SceneColor}>
                  <arcRotateCamera
                    name="camera"
                    target={LPC.CameraPosition}
                    alpha={LPC.CameraAlpha}
                    beta={LPC.CameraBeta}
                    radius={PW > LPC.PerspectiveRatio3 ? LPC.CameraRadius1 : LPC.CameraRadius2}
                    cameraDirection={LPC.CameraDirection}
                  />
                  <hemisphericLight name="light" direction={LPC.LightDirection} />
                  <box
                    position={
                      PW > LPC.PerspectiveRatio2
                        ? LPC.InitialBoxPosition1
                        : PW < LPC.PerspectiveRatio1
                        ? LPC.InitialBoxPosition2
                        : LPC.InitialBoxPosition3
                    }
                    isVisible={false}
                    rotation-x={Tools.ToRadians(LPC.InitialBoxRotationAngle)}
                    scaling-x={PW}
                    scaling-z={PW}
                  >
                    <standardMaterial diffuseColor={LPC.RedColor} />
                    {lightData?.map((light) => (
                      <box
                        key={light.outputId}
                        name={light.outputId}
                        position={new Vector3(-(light.left / 100).toFixed(3), 0, (light.top / 100).toFixed(3))}
                        width={(light.width / 100).toFixed(3)}
                        depth={(light.height / 100).toFixed(3)}
                        height={LPC.BoxHeight}
                        rotation-y={Tools.ToRadians(light.angle)}
                      >
                        <standardMaterial
                          diffuseColor={LIGHT_COLORS[light.outputColor]}
                          specularColor={LIGHT_COLORS[light.outputColor]}
                          emissiveColor={LPC.BlackColor}
                          name={light.outputId}
                        />
                      </box>
                    ))}
                  </box>
                </Scene>
              </Engine>
            </div>
            <div />
            <div className="table-responsive" style={{ height: "calc(100vh - 432px)" }}>
              <table className="table el-header table-bordered align-middle table-dark">
                <thead>
                  <tr>
                    <th>Lighthead Position</th>
                    <th>Source</th>
                    <th>Position</th>
                    <th>Calling Intensity</th>
                    <th>Blocking Intensity</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { pos: 2, source: "F5LBA - BLUE", location: "FRONT" },
                    { pos: "", source: "F5LBA - AMBER", location: "FRONT" },

                    { pos: 3, source: "F5LBA - BLUE", location: "FRONT" },
                    { pos: "", source: "F5LBA - AMBER", location: "FRONT" },

                    { pos: 4, source: "F5RBW - BLUE", location: "FRONT" },
                    { pos: "", source: "F5RBW - WHITE", location: "FRONT" },

                    { pos: 5, source: "F5RBW - BLUE", location: "FRONT" },
                    { pos: "", source: "F5RBW - WHITE", location: "FRONT" },

                    { pos: 7, source: "F5ERB - RED", location: "RIGHT" },
                    { pos: "", source: "F5ERB - BLUE", location: "RIGHT" },

                    { pos: 9, source: "F5RBA - BLUE", location: "REAR" },
                    { pos: "", source: "F5RBA - AMBER", location: "REAR" },

                    { pos: 10, source: "F5RBA - BLUE", location: "REAR" },
                    { pos: "", source: "F5RBA - AMBER", location: "REAR" },

                    { pos: 11, source: "F5LBWG - BLUE", location: "REAR" },
                    { pos: "", source: "F5LBWG - WHITE", location: "REAR" },
                    { pos: "", source: "F5LBWG - GREEN", location: "REAR" },

                    { pos: 12, source: "F5LBWG - BLUE", location: "REAR" },
                    { pos: "", source: "F5LBWG - WHITE", location: "REAR" },
                    { pos: "", source: "F5LBWG - GREEN", location: "REAR" },

                    { pos: 14, source: "F5ERB - RED", location: "LEFT" },
                    { pos: "", source: "F5ERB - BLUE", location: "LEFT" },
                  ].map((row) => (
                    <tr key={`${row.pos}-${row.source}-${row.location}`}>
                      <td>{row.pos}</td>
                      <td>{row.source}</td>
                      <td>{row.location}</td>

                      <td style={{ minWidth: "180px" }}>
                        <div className="form-group cursor-pt mb-0">
                          <Select
                            value={intensityOptions[2]}
                            options={intensityOptions}
                            className="select-sdd"
                            isSearchable={false}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                          />
                        </div>
                      </td>
                      <td style={{ minWidth: "180px" }}>
                        <div className="form-group cursor-pt mb-0">
                          <Select
                            value={intensityOptions[2]}
                            options={intensityOptions}
                            className="select-sdd"
                            isSearchable={false}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LightBarPreviewComponent;
